import { RowActionsMenu, type RowAction } from '../../../components/ui/RowActionsMenu'

type DriverActionsProps = {
  /** Names the row for assistive tech, e.g. "DRV-1024 — Amal Ahammed". */
  subject: string
  actions: RowAction[]
}

export const DriverActions = ({ subject, actions }: DriverActionsProps) => (
  <div className="flex w-full items-center justify-end gap-[8px]">
    <RowActionsMenu actions={actions} subject={subject} />
  </div>
)
